import store from "@frameworks/web/redux/store";
import { MARGIN_DATA, MARGIN_ERROR_DATA, MARGIN_HIDE_ERROR_DATA, MARGIN_START_LOADER, MARGIN_STOP_LOADER, } from "../interface/ICalculateMargin";
class CalculateMarginActions {
    constructor() {
        this.dispatch = store.dispatch;
    }
    getCalculatedMargin(margin) {
        this.dispatch({
            type: MARGIN_DATA,
            payload: { data: margin },
        });
    }
    setError(payload, errorType) {
        this.dispatch({
            type: MARGIN_ERROR_DATA,
            payload: { errorData: payload },
        });
    }
    hideError(errorType) {
        this.dispatch({
            type: MARGIN_HIDE_ERROR_DATA,
        });
    }
    startLoader() {
        this.dispatch({
            type: MARGIN_START_LOADER,
        });
    }
    stopLoader() {
        this.dispatch({
            type: MARGIN_STOP_LOADER,
        });
    }
}
export default CalculateMarginActions;
